import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { observer } from 'mobx-react';
import { Position } from '@blueprintjs/core';
import { Popover } from 'core/components';
const DropdownMenu = ({
  children,
  className,
  ...props
}) => /*#__PURE__*/React.createElement(Popover, _extends({
  position: Position.BOTTOM_RIGHT,
  popoverClassName: className,
  openOnTargetFocus: true,
  minimal: true
}, props), children);
export default observer(DropdownMenu);